import {onFind} from "@elements/init-modules-in-scope";
export function init() {
    let checkSocialWallConsent = setInterval(function(){
        let consent = _config.socialWallConsentGiven;
        if(consent) {
            initSocialWall(true);
            clearInterval(checkSocialWallConsent);
        }
    }, 250)

    function initSocialWall(cookieAccepted) {
        onFind('.js-socialwall', function () {
            //add js
            let script = document.createElement('script');
            script.src = "https://assets.juicer.io/embed.js";
            script.type = "text/javascript";
            document.head.appendChild(script);


            //add css
            let link = document.createElement('link');
            link.href = "https://assets.juicer.io/embed.css";
            link.type = "text/css";
            link.rel = "stylesheet";
            link.media = "all";
            document.head.appendChild(link);

            //get data-feed-id and append <ul class="juicer-feed" ></ul>
            let feedId = document.querySelector('.js-socialwall').getAttribute('data-feed-id');
            let ul = document.createElement('ul');
            ul.className = "juicer-feed";
            ul.setAttribute('data-feed-id', feedId);
            document.querySelector('.js-socialwall').appendChild(ul);
        });
    }
}